<template>
    <b-modal size="sm" button-size="sm" v-model="showModal" :title="title" hide-footer @hidden="cancelar">
        <b-container>
            <b-row>
                <b-col>
                    <b-form @submit.prevent="submitForm">
                        <lg-form-input v-model="form.codigo" label="Código CNAE: *" required></lg-form-input>

                        <lg-form-input v-model="form.descricao" label="Descrição: *" required></lg-form-input>

                        <b-form-group label="Principal" class="col-12">
                            <div class="checkbox-container">
                                <input type="checkbox" id="principalCheckbox" v-model="form.principal"
                                    class="checkbox-input">
                                <label for="principalCheckbox" class="checkbox-label">
                                    Principal
                                </label>
                            </div>
                        </b-form-group>

                        <div class="d-flex justify-content-center mt-3">
                            <b-button type="submit" variant="success" style="height: 30px" pill size="sm">
                                <div>
                                    <b-icon icon="check-circle" />
                                </div>
                            </b-button>
                            <b-button class="ml-2" @click="cancelar" style="height: 30px" pill size="sm"
                                variant="danger">
                                <div>
                                    <b-icon icon="x-circle" />
                                </div>
                            </b-button>
                        </div>
                    </b-form>
                </b-col>
            </b-row>
        </b-container>
    </b-modal>
</template>

<script>
import LgFormInput from "@/core/components/Form/LgFormInput.vue";
import ConfirmMixin from "@/core/mixins/confirm";
import ResourceService from "@/core/api/ResourceService";
import { FormResourceMixin } from "@/core/mixins/resource";

export default {
    components: {
        LgFormInput,
    },
    data() {
        return {
            showModal: true,
            form: {
                codigo: "",
                descricao: "",
                principal: false,
                empresa: {
                    id: this.codEmpresa
                }
            },
        };
    },
    mixins: [ConfirmMixin, FormResourceMixin],
    props: {
        prefix: {
            type: Array,
            required: true,
        },
        id: {
            type: Number,
            default: null,
        },
        codEmpresa: {
            type: Number,
            required: true,
        },
    },
    async beforeMount() {
        this.$service = new ResourceService(`/api/empresacnae`);

        if (this.id) {
            const { data } = await this.$service.findById(this.id);

            if (data.principal === null || data.principal === undefined) {
                data.principal = false;
            }

            this.form = data;
            this.form.empresa = { id: this.codEmpresa };
        }
    },
    computed: {
        updatedPrefix() {
            return [...this.prefix, "Cadastro"];
        },
        title() {
            return this.updatedPrefix.join(" > ");
        },
    },
    methods: {
        formatarCodigo(value) {
            return value.replace(/[^\d.-]/g, "").slice(0, 20);
        },
        async submitForm() {
            try {
                await this.$service.save(this.form);

                this.$notify({
                    type: "success",
                    message: 'Registro salvo com sucesso'
                });
                this.cancelar();

            } catch (error) {
                this.$notify({
                    type: "danger",
                    message: error.response.data
                });
                return;
            }
        },
        cancelar() {
            this.$emit("fechar");
        },
    },
};
</script>

<style scoped>
.btn-size-alinhamento {
    display: flex;
    align-items: center;
    justify-content: center;
}

.checkbox-container {
    display: flex;
    align-items: center;
    margin-top: 10px;
}

.checkbox-input {
    cursor: pointer;
    width: 20px;
    height: 20px;
    margin-right: 10px;
}

.checkbox-label {
    cursor: pointer;
    font-weight: bold;
    user-select: none;
}
</style>
